import { Add, Delete, Edit } from "@mui/icons-material";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import { RemoveRedEye } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import EmptyContent from "components/EmptyContent";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import React, {  useState } from "react";
import { QueryClient, useMutation } from "react-query";
import Search from "components/Search/Search";
import { handleError } from "helpers/utils";
import useFetchSection from "hooks/useFetchSection";
import DeleteModal from "components/UI/Form/partials/Delete";
import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import { addReseller, deleteReseller, editReseller, getReseller, ResellersCells } from "framework/reseller";
import { IReseller, IResellerInput } from "models/reseller";
import phone from 'phone';
import AddModalReseller from "./partials/Add";
import EditModalReseller from "./partials/Edit";
import ViewClientsModal from "./partials/View";

interface Props {
  feature: Feature;
}


function isValidNumber(countryCodeNumeric: string): boolean {
  const {isValid} = phone(countryCodeNumeric);
  return  isValid;
  
}

const Resellers: React.FC<Props> = ({ feature }) => {
  const [loading2, setLoading2] = useState<boolean>(false);
  const [FilterResellers, setFilterResellers] = useState<IReseller[]>([] as IReseller[]);
  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openView, setOpenView] = useState<boolean>(false);
  const [selectedReseller, setSelectedReseller] = useState<IReseller|null>(null);
  const [inputObj, setInputObj] = useState<IResellerInput>({} as IResellerInput);
  const { setAlert } = useAlert();

  // eslint-disable-next-line
  const queryClient = new QueryClient();

  const addResellerMutation = useMutation({
    mutationFn: (createInput: IResellerInput) => {
      return addReseller(createInput);
    },
  });

  const editResellerMutation = useMutation({
    mutationFn: (data: { createInput: IResellerInput; resellerId: string }) => {
      return editReseller(data.createInput, data.resellerId);
    },
  });

  const deleteClientMutation = useMutation({
    mutationFn: (id: string) => {
      return deleteReseller(id);
    },
  });




  const {
    loading,
    data: Resellers,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getReseller(),
    fetchPermission: async () => null,
    section: "Resellers",
    onSuccess: (data) => setFilterResellers(data),
  
  });

  if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  const handleChange = (name: string, value: any) => {
    setInputObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenAdd = () =>{
    setOpenAdd(true);
    setInputObj((prev) => ({
      ...prev,
      countryCode: '+961',
    }));
  } 

  const handleOpenEdit = (reseller: IReseller) => {
    setSelectedReseller(reseller);
    setOpenEdit(true);
  };

  const handleOpenDelete = (reseller: IReseller) => {
    setSelectedReseller(reseller);
    setOpenDelete(true);
  };

  const handleOpenView = (reseller: IReseller) => {
    setSelectedReseller(reseller);
    setOpenView(true);
  };



  const handleClose =()=>{
    setOpenAdd(false)
    setOpenEdit(false);
    setOpenDelete(false);
    setOpenView(false)
    setSelectedReseller(null);
    setInputObj({} as IResellerInput)
  }

  const getBodyCells = (row: IReseller) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "resellerName")
        return {
          id: "resellerName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.resellerName}</Typography>
            </TableCell>
          ),
        };
      if (key === "countryCode")
        return {
          id: "countryCode",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.countryCode}</Typography>
            </TableCell>
          ),
        };

      if (key === "phoneNumber")
        return {
          id: "phoneNumber",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.phoneNumber}</Typography>
            </TableCell>
          ),
        };
  

      if (key === "resellerId")
        return {
          id: "actions",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
              >
                
                  <Tooltip title={"Edit"}>
                    <IconButton
                      size={"small"}
                      color={"primary"}
                      onClick={() => handleOpenEdit(row)}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
              
          
                  <Tooltip title={"Delete"}>
                    <IconButton
                      size={"small"}
                      sx={{
                        color: "red",
                      }}
                      onClick={() => handleOpenDelete(row)}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>


                  <Tooltip title={"View Clients Subscriptions"}>
                    <IconButton
                      size={"small"}
                      sx={{
                        color: "#9e9e52",
                      }}
                      onClick={() => handleOpenView(row)}
                    >
                      <RemoveRedEye />
                    </IconButton>
                  </Tooltip>
            
              </Stack>
            </TableCell>
          ),
        };
    });
    return cells;
  };

  const handleAdd = async () => {


      if (
        !isValidNumber(inputObj.countryCode + inputObj.phoneNumber ))
        
      
        return setAlert({
          open: true,
          message: "This Phone is not valid in this country",
          type: "error",
        });

    try {
      setLoading2(true);

      await addResellerMutation.mutateAsync(inputObj);
      setAlert({
        open: true,
        message: "Reseller added successfully",
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IResellerInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleEdit = async () => {


    if (inputObj.resellername === ''  || inputObj.phoneNumber === '' )
      return setAlert({
        open: true,
        message: "Please fill all fields",
        type: "error",
      });

    if (
      !isValidNumber((inputObj.countryCode || selectedReseller!?.countryCode) + ( inputObj.phoneNumber || selectedReseller!?.phoneNumber) ))
      
    
      return setAlert({
        open: true,
        message: "This Phone is not valid in this country",
        type: "error",
      });
      
      let createInput: IResellerInput = {
        ...inputObj
      };
    try {
      setLoading2(true);
      await editResellerMutation.mutateAsync({
        createInput,
        resellerId:selectedReseller!?.resellerId.toString()
      });

     

      setAlert({
        open: true,
        message: "Reseller updated successfully",
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IResellerInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading2(true);
      await deleteClientMutation.mutateAsync(selectedReseller!.resellerId.toString());
      setAlert({
        open: true,
        message: "Reseller deleted successfully",
        type: "success",
      });
      revalidate();
      handleClose();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleSearch = async (value: string) => {
    if (!value) return setFilterResellers(Resellers!);
    let filtered = Resellers!.filter((client) =>
      client.resellerName.toLowerCase().includes(value.toLowerCase()) || client.countryCode.toLowerCase().includes(value.toLowerCase()) || client.phoneNumber.toLowerCase().includes(value.toLowerCase()) 
    );
    setFilterResellers(filtered);
  };



  

  let addBasicFields: IFormField[] = [
    {
      name: 'resellername',
      label: 'Reseller Name',
      type: InputTypes.TEXT,
      placeholder: 'Enter Reseller Name',
      internalLabel: true,
      required: true
    }
  ];


  let editBasicFields: IFormField[] = [
    {
      name: 'resellername',
      label: 'Reseller Name',
      type: InputTypes.TEXT,
      placeholder: 'Enter Reseller Name',
      defaultValue: selectedReseller? selectedReseller.resellerName:'',
      internalLabel: true,
      required: true
    },
  ];


  return (
    <>
      <Stack spacing={2} p={2}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"
          sx={{ mb: 4 }}
        >
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Typography
              variant="h3"
              color={ "header.primary"}
            >
              {(feature.name)}
            </Typography>
          
              <Tooltip title={"Add"}>
                <IconButton
                  sx={{
                    color: "red",
                    height: 40,
                    width: 40,
                    transition: "0.5s",
                  }}
                  onClick={handleOpenAdd}
                >
                  <Add />
                </IconButton>
              </Tooltip>
      
          </Stack>
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Stack
              direction={{ lg: "row", xs: "column" }}
              spacing={1}
              width={"100%"}
            >
              <Search handleChange={handleSearch} placeholder={"Search"} />
            </Stack>
          </Stack>
        </Grid>

        { FilterResellers.length > 0 && (
          <List
            headCells={ResellersCells}
            data={FilterResellers}
            getBodyCells={getBodyCells}
            feature={feature}
            canEdit={false}
          />
        )}
        {(!FilterResellers || FilterResellers.length === 0) &&
           
            <EmptyContent
              icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
              header={"No Resellers"}
              message={"No Reseller Exists Yet"}
            />
          }

      
      </Stack>

      {openAdd && (
        <AddModalReseller
          open={openAdd}
          loading={loading2}
          disabled={!inputObj.countryCode || !inputObj.phoneNumber || !inputObj.resellername }
          title="Add Reseller"
          basicFields={addBasicFields}
          onClose={handleClose}
          onSubmit={handleAdd}
          onChanges={handleChange}
        />
      )}
      {openEdit && (
        <EditModalReseller
          open={openEdit}
          loading={loading2}
          title="Edit Reseller"
          disabled={!inputObj.countryCode && !inputObj.phoneNumber && !inputObj.resellername }
          reseller={selectedReseller!}
          basicFields={editBasicFields}
          onClose={handleClose}
          onSubmit={handleEdit}
          onChanges={handleChange}
        />
      )}
      {openDelete && (
        <DeleteModal
          open={openDelete}
          loading={loading2}
          title="Delete Reseller"
          description="Are You Sure You Want to delete this reseller"
          onClose={handleClose}
          onSubmit={handleDelete}
        />
      )}
       {openView && (
        <ViewClientsModal
          open={openView}
          title="View Client Subscriptions"
          feature={feature}
          id={selectedReseller!?.resellerId}
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default Resellers;
